<script>
    export default {
        name: "HtmlSection",
    }
</script>
